import styled from "styled-components";
import { colors } from "../../../../../consts";

import { Paragraph2, WrapperContainer } from "../../../../../components";
import { RadialChartContainer } from "../../../../../components/Charts/styled";
import { Header } from "../../../../../components/Modal/styled";

export const DetailedReportModalWrapper = styled(WrapperContainer)`
  ${Header} {
    margin-bottom: 0px !important;
  }
`;

export const InfoContainer = styled(WrapperContainer)`
  > ${Paragraph2} {
    color: ${colors.RAISIN_70};
    font-weight: 500;
    font-size: 16px;
    line-height: 26px;
  }
`;

export const HorizontalChartWrapper = styled(WrapperContainer)`
  ${RadialChartContainer} {
    flex-direction: row !important;
    justify-content: center;
    gap: 64px;
  }
`;
